import { roundDecimalValueUptoTwo } from "./roundDecimalValue";

export const calculateTotalMrpByNsvDisc = (NSV, DIS_PERCENT) => {
	if (DIS_PERCENT === 0) return NSV;
	if (!NSV) return 0;
	if (DIS_PERCENT > 1) DIS_PERCENT = DIS_PERCENT / 100;
	const val = NSV / (1 - DIS_PERCENT);
	console.log(val, DIS_PERCENT, NSV, "mrp");
	return val;
};
export const calculateNsvWithProjection = (dataObj) => {
	if (!dataObj["NSV_ACH_VAL"] && !dataObj["PROJ_NSV"]) return 0;
	const val = +dataObj["NSV_ACH_VAL"] + +dataObj["PROJ_NSV"];

	return val;
};
export const calculateNsvAchVsAop = (dataObj) => {
	const val = (dataObj["NSV_ACH_VAL"] / dataObj["NSV_AOP_VAL"]) * 100 ?? 0;
	return val;
};
export const calculateNsvAchWithProjectionVsAop = (dataObj) => {
	const nsvWithProj = calculateNsvWithProjection(dataObj);
	if (!nsvWithProj) return 0;

	const val = (nsvWithProj / dataObj["NSV_AOP_VAL"]) * 100 ?? 0;
	return val;
};
export const calculateNsvLost = (dataObj) => {
	const nsvWithProj = calculateNsvWithProjection(dataObj);
	if (!nsvWithProj) return 0;
	const val = +dataObj["NSV_AOP_VAL"] - nsvWithProj;
	return val;
};

export const calculateProjectionDisPercentByMrpRev = (dataObj) => {
	// console.log(dataObj, dataObj["PROJ_TOTAL_MRP"], dataObj["PROJ_NSV"], "calculateProjectionDisPercentByMrpRev");
	if (!dataObj["PROJ_TOTAL_MRP"] || !dataObj["PROJ_NSV"]) return 0;
	const val = (1 - dataObj["PROJ_NSV"] / dataObj["PROJ_TOTAL_MRP"]) * 100;
	return val;
};
export const calculateProjectionGpWithCm = (dataObj) => {
	const projTaxable = isNaN(dataObj["PROJ_CM_TAXABLE_VAL"]) ? 0 : +dataObj["PROJ_CM_TAXABLE_VAL"];
	const projectedCogs = isNaN(dataObj["PROJ_TOTAL_COGS"]) ? 0 : +dataObj["PROJ_TOTAL_COGS"];

	let val = projTaxable - projectedCogs;
	return val;
};

// GP With Channel margin
export const calculateGpWithCmAOPPercentOfRev = (dataObj) => {
	if (!dataObj["CM_GP_AOP_VAL"] || !dataObj["CM_TAXABLE_AOP_VAL"]) return 0;
	let val = (dataObj["CM_GP_AOP_VAL"] / dataObj["CM_TAXABLE_AOP_VAL"]) * 100;

	return val;
};
export const calculateGpWithCmACHPercentOfRev = (dataObj) => {
	if (!dataObj["CM_GP_ACH_VAL"] || !dataObj["CM_TAXABLE_ACH_VAL"]) return 0;
	let val = (dataObj["CM_GP_ACH_VAL"] / dataObj["CM_TAXABLE_ACH_VAL"]) * 100;
	return val;
};
export const calculateGpWithCmAchDiffAopPercentOfRev = (dataObj) => {
	const ach_percent_of_rev = calculateGpWithCmACHPercentOfRev(dataObj);
	const aop_percent_of_rev = calculateGpWithCmAOPPercentOfRev(dataObj);
	if (!ach_percent_of_rev && aop_percent_of_rev) return 0;
	let val = ach_percent_of_rev - aop_percent_of_rev;
	return val;
};
export const calculateGpWithProjIncludingCm = (dataObj) => {
	const revTaxable = isNaN(dataObj["CM_TAXABLE_ACH_VAL"]) ? 0 : +dataObj["CM_TAXABLE_ACH_VAL"];
	const projTaxable = isNaN(dataObj["PROJ_CM_TAXABLE_VAL"]) ? 0 : +dataObj["PROJ_CM_TAXABLE_VAL"];
	const revCogs = isNaN(dataObj["COGS_REV"]) ? 0 : +dataObj["COGS_REV"];
	const projectedCogs = isNaN(dataObj["PROJ_TOTAL_COGS"]) ? 0 : +dataObj["PROJ_TOTAL_COGS"];

	let val = revTaxable + projTaxable - (revCogs + projectedCogs);
	return val;
};

export const calculateGpWithProjPercentOfRevIncludingCm = (dataObj) => {
	const gpWithProj = calculateGpWithProjIncludingCm(dataObj);
	const revTaxable = isNaN(dataObj["CM_TAXABLE_ACH_VAL"]) ? 0 : +dataObj["CM_TAXABLE_ACH_VAL"];
	const projTaxable = isNaN(dataObj["PROJ_CM_TAXABLE_VAL"]) ? 0 : +dataObj["PROJ_CM_TAXABLE_VAL"];

	if (!gpWithProj || (!revTaxable && !projTaxable)) return 0;

	let val = (gpWithProj / (revTaxable + projTaxable)) * 100;
	return val;
};
export const calculateGpWithProjAchPercentIncludingCm = (dataObj) => {
	const gpWithProj = calculateGpWithProjIncludingCm(dataObj);
	const gpAOP = +dataObj["CM_GP_AOP_VAL"];
	if (!gpWithProj || !gpAOP) return 0;

	let val = (gpWithProj / gpAOP) * 100;
	return val;
};
export const calculateGpWithProjPercentOfRevAchPercentIncludingCm = (dataObj) => {
	const gpWithProjPercentOfRev = calculateGpWithProjPercentOfRevIncludingCm(dataObj);
	const gpWithAopPercentOfRev = calculateGpWithCmAOPPercentOfRev(dataObj);

	let val = gpWithProjPercentOfRev - gpWithAopPercentOfRev;
	return val;
};
export const calculateGpWithCmGpLost = (dataObj) => {
	const gpWithProj = calculateGpWithProjIncludingCm(dataObj);
	const gpAOP = +dataObj["CM_GP_AOP_VAL"];
	// if (!gpWithProj || !gpAOP) return 0;

	let val = gpAOP - gpWithProj;
	return val;
};

// GP Without Channel margin
export const calculateGpWithoutCmAOPPercentOfRev = (dataObj) => {
	if (!dataObj["GP_AOP_VAL"] || !dataObj["TAXABLE_AOP_VAL"]) return 0;
	let val = (dataObj["GP_AOP_VAL"] / dataObj["TAXABLE_AOP_VAL"]) * 100;

	return val;
};
export const calculateGpWithoutCmACHPercentOfRev = (dataObj) => {
	if (!dataObj["GP_ACH_VAL"] || !dataObj["TAXABLE_ACH_VAL"]) return 0;
	let val = (dataObj["GP_ACH_VAL"] / dataObj["TAXABLE_ACH_VAL"]) * 100;
	return val;
};
export const calculateGpWithoutCmAchDiffAopPercentOfRev = (dataObj) => {
	const ach_percent_of_rev = calculateGpWithoutCmACHPercentOfRev(dataObj);
	const aop_percent_of_rev = calculateGpWithoutCmAOPPercentOfRev(dataObj);
	if (!ach_percent_of_rev && aop_percent_of_rev) return 0;
	let val = ach_percent_of_rev - aop_percent_of_rev;
	return val;
};

export const calculateGpWithProjExcludingCm = (dataObj) => {
	const revTaxable = isNaN(dataObj["TAXABLE_ACH_VAL"]) ? 0 : +dataObj["TAXABLE_ACH_VAL"];
	const projTaxable = isNaN(dataObj["PROJ_TAX"]) ? 0 : +dataObj["PROJ_TAX"];
	const revCogs = isNaN(dataObj["COGS_REV"]) ? 0 : +dataObj["COGS_REV"];
	const projectedCogs = isNaN(dataObj["PROJ_TOTAL_COGS"]) ? 0 : +dataObj["PROJ_TOTAL_COGS"];

	let val = revTaxable + projTaxable - (revCogs + projectedCogs);
	return val;
};

export const calculateGpWithProjPercentOfRevExcludingCm = (dataObj) => {
	const gpWithProj = calculateGpWithProjExcludingCm(dataObj);
	const revTaxable = isNaN(dataObj["TAXABLE_ACH_VAL"]) ? 0 : +dataObj["TAXABLE_ACH_VAL"];
	const projTaxable = isNaN(dataObj["PROJ_TAX"]) ? 0 : +dataObj["PROJ_TAX"];

	if (!gpWithProj || (!revTaxable && !projTaxable)) return 0;

	let val = (gpWithProj / (revTaxable + projTaxable)) * 100;
	return val;
};
export const calculateGpWithProjAchPercentExcludingCm = (dataObj) => {
	const gpWithProj = calculateGpWithProjExcludingCm(dataObj);
	const gpAOP = +dataObj["GP_AOP_VAL"];
	if (!gpWithProj || !gpAOP) return 0;

	let val = (gpWithProj / gpAOP) * 100;
	return val;
};

export const calculateGpWithProjPercentOfRevAchPercentExcludingCm = (dataObj) => {
	const gpWithProjPercentOfRev = calculateGpWithoutCmACHPercentOfRev(dataObj);
	const gpWithAopPercentOfRev = calculateGpWithoutCmAOPPercentOfRev(dataObj);

	let val = gpWithProjPercentOfRev - gpWithAopPercentOfRev;
	// let val = gpWithProjPercentOfRev;
	return val;
};

export const calculateGpLostExcludingCm = (dataObj) => {
	const gpWithProj = calculateGpWithProjExcludingCm(dataObj);
	const gpAOP = +dataObj["GP_AOP_VAL"];
	// if (!gpWithProj || !gpAOP) return 0;

	let val = gpAOP - gpWithProj;
	return val;
};
